const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls } = wp.blockEditor;

const {
	FormTokenField,
	PanelBody,
	PanelRow,
	Disabled,
	RangeControl,
	SelectControl,
	TextControl,
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;
const { withSelect } = wp.data;
const { createElement: el } = wp.element;
import icons from "../../../icons.js";

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
 registerBlockType("wp-apidae/next-events", {
	title: __("Liste d'événements à venir", "wp-apidae"), // Block title.
	description: __("Affiche les prochaines activités et fêtes et manifestation", "wp-apidae"),
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.entitiesList
	},
	supports: {
    align: true,
  },
	attributes: {
		selection: {
			type: "number",
			default: 0,
		},
		post_type: {
      type: "string",
      default: "any",
    },
		limit: {
      type: "number",
      default: 3,
    },
		columns: {
			type: "number",
			default: 2,
		},
		align: {
			type: 'string',
			default: '',
		},
	},
	edit: class extends wp.element.Component {
		render() {const props = this.props;
			const attributes = props.attributes;
			const selections = window.WpApidaeTemplateData.selections;

			/**
     * Set Apidae Post Types
     */
			 function onChangePostType(value) {
				props.setAttributes({ post_type: value });
			}

			const post_types_list = [{ value: "any", label: "F&MA et activités" },{ value: "ad_fete_et_manifesta", label: "F&MA" },{ value: "ad_activite", label: "Activités" }];

			return [
				<InspectorControls key={"inspector"}>
						<PanelBody title={__("General")}>
							<PanelRow>
							<SelectControl
								label={__("Sélection")}
								value={attributes.selection}
								options={selections}
								onChange={(newValue) => {
									props.setAttributes({
										selection: Number(newValue),
									});
								}}
							/>
							</PanelRow>
						<PanelRow>
							<SelectControl
									onChange={onChangePostType}
									value={attributes.post_type}
									label={__("Choisir un type de fiche", "wp-apidae")}
									options={post_types_list}
								/>
					</PanelRow>
					<PanelRow>
          <RangeControl
              label='Nombre de fiches'
							value={attributes.limit}
							min={0}
							max={100}
							onChange={(newValue) => {
								props.setAttributes({ limit: Number(newValue) });
							}}
						/>
						</PanelRow>
						<PanelRow>
						<TextControl
								type="number"
								label={__("Nombre de colonnes")}
								value={attributes.columns}
								min={`1`}
								max={`5`}
								onChange={(newValue) => {
									props.setAttributes({ columns: Number(newValue) });
								}}
							/>
          </PanelRow>
					</PanelBody>
					</InspectorControls>,
					<Disabled>
					<ServerSideRender
						block="wp-apidae/next-events"
						attributes={attributes}
						/>
				</Disabled>
			];
		}
	},

	save: () => {
		return null;
	},
});
